module.exports = __webpack_public_path__ + "video/SERF25-0900-Generative_AI.8ef1d1aa.vtt";